export default __webpack_public_path__ + "static/media/VehicleDetailTemplate.93c6e202.csv";